/* global AUDIO_URL_DEV_PROXY */
import { type ParsedUrlQuery } from 'querystring';
import url, { type Url } from 'url';

export const getUrlQueryParameters = (): ParsedUrlQuery => {
  const href = window?.location?.href || '';
  return url.parse(href, true).query;
};

export const getCurrentUrlPath = (): string => {
  return window?.location?.pathname || '';
};

export const getUrlHostName = (): string => {
  return window?.location?.hostname || '';
};

export const getUrlPort = (): string => {
  return window?.location?.port || '';
};

export const isProductionUrl = (): boolean => {
  const urlHost = getUrlHostName();
  return urlHost === 'www.pandora.com';
};

export const isUrlLocal = (urlString: string): boolean => {
  const { hostname } = url.parse(urlString);
  return hostname === getUrlHostName();
};

export const getUrlParseObject = (urlString: string, parseQueryString = false): Url => {
  return url.parse(urlString, parseQueryString);
};

export const getProxiedAudioURL = (originalAudioUrl: string): string => {
  const parsedUrl = url.parse(originalAudioUrl);
  const { hostname, path, protocol = 'https:' } = parsedUrl;
  const port = parsedUrl.port ? parsedUrl.port : protocol === 'https:' ? '443' : '80';
  const originalHost = encodeURIComponent(protocol + '//' + hostname + ':' + port);
  return `${AUDIO_URL_DEV_PROXY}${path}&originalHost=${originalHost}`;
};
